<template>
  <div class="page print-info-area fs13 p20 mb-4">
    <PDFHeader :flg="true" :title="$t('vaccination')"/>
    <div class="bodyPDF">
      <div class="detail-content-area ">
        <div class="vaccin-table">
          <table :style="[maxGettingVaccin >=6 ? {fontSize: '12px'} : {}]">
            <tr>
              <th :style="styleWidthOfCell('firstCol')">{{ $t('vaccine_name') }}</th>
              <th v-for="shot in maxGettingVaccin" :key="shot" :style="styleWidthOfCell()">{{ $tc('number_of_shot_vaccin', shot) }}</th>
            </tr>
            <tr v-for="(item, index) in vaccinations" :key="index">
              <td :style="styleWidthOfCell('firstCol')">{{ item.name }}</td>
              <td :class="value.answer_value == 'no-vacxin-date' ? 'background' : null " v-for="(value, key) in item.date" :key="key" :style="styleWidthOfCell()">
                {{ value.answer_value ? (value.answer_value == 'no-vacxin-date' ? '' : convertToJPTime(value.answer_value)) : '－' }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const HEIGHT_OF_TITLE = 36
const HEIGHT_OF_SPACE_AREA = 973
const WIDTH_OF_ROW = 754
import { mapState } from 'vuex'
import { convertToJPTime } from '@/js/commons/commons'
import PDFHeader from '../PDFHeader.vue'
export default {
  components: {
    PDFHeader,
  },
  computed: {
    ...mapState({
      vaccinations: state => state.homecare.vaccinPdf.vaccinData,
      maxGettingVaccin: state => state.homecare.vaccinPdf.maxGettingVaccin,
    }),
  },
  mounted() {
    let spaceArea = HEIGHT_OF_SPACE_AREA - HEIGHT_OF_TITLE
    let listElOnNewPage = []
    let indexNewPage = -1
    document.querySelectorAll('.vaccin-table tr').forEach(row => {
        spaceArea -= row.offsetHeight
        if(spaceArea < 0) {
          indexNewPage++
          listElOnNewPage.push([])
          listElOnNewPage[indexNewPage].push(row.innerHTML)
          spaceArea = HEIGHT_OF_SPACE_AREA - row.offsetHeight
          row.classList.add('d-none')
        }
        else if(indexNewPage > -1) {
          listElOnNewPage[indexNewPage].push(row.innerHTML)
          row.classList.add('d-none')
        }
    })
    listElOnNewPage.forEach(list => {
      this.addNewPage(list)
    })
  },
  methods: {
    styleWidthOfCell(col = null) {
      let width = (WIDTH_OF_ROW/(this.maxGettingVaccin+1) + (col === 'firstCol' ? 10 : - Math.floor(10/(this.maxGettingVaccin+1)) ) ) + 'px'
      return {
        minWidth: width,
        maxWidth: width,
        width: width,
        fontSize: "11px",
        lineHeight: "20px",
      }
    },
    convertToJPTime(time) {
      return convertToJPTime(time)
    },
    addNewPage(listDeseaseEl) {
      let headerEl = document.getElementsByClassName('header')[0].outerHTML
      let newPage = document.createElement('div')
      newPage.classList.add('page', 'print-info-area', 'fs13', 'p20', 'mb-4')
      newPage.style.backgroundColor = 'white'
      newPage.style.height = '1123px'
      newPage.style.marginTop = '20px'
      newPage.innerHTML = ''
      var newEl = ''
      newEl += headerEl
      newEl += `
        <div class="bodyPDF">
          <div class="detail-content-area">
            <div class="vaccin-table">
              <table style="${this.maxGettingVaccin >=6 ? 'font-size: 12px' : ''}">`
      listDeseaseEl.forEach(deseaseName => newEl += `<tr>${deseaseName}</tr>`)
      newEl += `
              </table>
            </div>
          </div>
        </div>`
      newPage.insertAdjacentHTML('beforeend', newEl)
      document.getElementsByClassName('homecare-topic-area')[1].appendChild(newPage)
    }
  }
}
</script>